<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <gTop />
    <gHead />
    <gNav />
    <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <!-- 展商信息 -->
      <div class="company_info" v-if="comInfo">
        <div class="img">
          <img :src="comInfo.logo" class="empty-img" v-if="comInfo.logo" />
          <img src="@assets/img/empty.png" class="empty-img" v-else />
        </div>
        <div class="info">
          <h3 title v-if="comInfo.nameEn">{{comInfo.nameEn}}</h3>
           <h3 title v-else>{{comInfo.name}}</h3>
          <div class="m-info-brand">
            <div class="brand">
              <i class="icon iconfont icon-tubiao-"></i>
              <span>{{comInfo.followCount}}</span>
            </div>
            <div class="brand">
              <i class="icon iconfont icon-share"></i>
              <span>{{comInfo.shareCount}}</span>
            </div>
            <div class="brand">
              <i class="icon iconfont icon-liuyan4"></i>
              <span>{{comInfo.commentCount}}</span>
            </div>
            <div class="brand">
              <i class="icon iconfont icon-chakan"></i>
              <span>{{comInfo.viewCount}}</span>
            </div>
          </div>
          <div class="m-info-line" v-if="comInfo.listBoothInfo.length>0">
            <i class="icon iconfont icon-dot" style="color: rgb(209, 49, 25);"></i>
            <!-- <template v-for="(item,index) in comInfo.listBoothInfo">
                <span v-if="item.boothInfo[0].Code&&item.boothInfo[0].Hall" style="margin-right:20px">
                  <span style="padding-left: 0px;" >{{item.shortName}}  -  {{item.boothInfo[0].Code||''}}-{{item.boothInfo[0].Hall||''}}</span>
                </span>
                
            </template>   -->
           <span v-if='comInfo.boothInfo'> {{ JSON.parse(comInfo.boothInfo)[0].Hall }}-{{ JSON.parse(comInfo.boothInfo)[0].Code }}</span>
          </div>
          <div class="m-info-line" v-if="categories">
            <i class="icon iconfont icon-biaoqian1" style="color: #329bba;"></i>
            <span>{{categories}}</span>
          </div>
          <p v-if="comDetail && comDetail.website" style="color:#000;margin-top:10px;">Website：<span class="website" @click="goWebsite">{{comDetail.website}}</span></p>
        </div>
        <div class="btn">
          <Button type="info" ghost style="width:90px;height:35px;font-size:14px;" :disabled="comInfo.isFollow" @click="addCollect">Follow</Button>
          <!-- <Button type="info" ghost style="width:90px;height:35px;font-size:14px;color:#dcdee2;border-color:#dcdee2;">已收藏</Button> -->
          <Button
            type="error"
            ghost
            style="height:35px;font-size:14px;margin-left:20px;"
            @click="supply()"
          >Start talking</Button>
        </div>
      </div>
      <!-- 展商内容 -->
      <div class="main">
        <div class="section">
          <div class="section-top" v-if="introduction">
            <div class="title">
              <span></span>
              <h3>企业介绍</h3>
            </div>
            <div class="m-content">
              <div v-for="(item,index) in introduction" :key="index">
                <!-- 文字 -->
                <p
                  class="int-text"
                  v-if="item.text"
                  style="padding:10px 0;"
                  :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
                  v-html="item.text.content ? $service.replaceSpeace(item.text.content) : '暂无介绍'"
                ></p>
                <!-- 图片 -->
                <div
                  class="int-img"
                  style="font-size:0;"
                  v-if="item.picture && item.picture.type == 1"
                  :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}"
                >
                  <div
                    v-for="(itm,idx) in item.picture.list"
                    :key="idx"
                    :style="{'margin-bottom':item.picture.spacing+'px'}"
                  >
                    <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)" />
                  </div>
                </div>
                <!-- 轮播图片 -->
                <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
                  <gSwiperCommon v-if="comInfo" :comInfo="comInfo" :list="item.picture.list"></gSwiperCommon>
                </div>
                <!-- 视频 -->
                <div class="int-video" v-if="item.video">
                  <video
                    style="width:100%;height:100%;object-fit:fill;"
                    :src="item.video.link"
                    :poster="item.video.cover?item.video.cover:''"
                    controls="controls"
                  >您的浏览器不支持video标签</video>
                </div>
              </div>
            </div>
          </div>
          <div class="section-bot">
            <proList></proList>
          </div>
          <!-- <div class="section-bot">
            <leavingmessage @showLogin="show=true;" :typeId="compId" v-if="compId" :type="'ex'"></leavingmessage>
          </div> -->

          <!-- 品牌 -->
          <div class="section-brand" v-if="brandList && brandList.length">
            <div style="box-shadow:0px 1px 3px 0px rgba(95, 99, 104, 0.1);">
              <div class="title-top">
                <span></span>
                <h3>Brands</h3>
              </div>
              <div class="section-brand-list">
                <div v-for="(item,index) in brandList" @click="brandFlag=true;brandInfo=item;" :key="index" :style="(index+1)%6 === 0?{'margin':'0 0 20px 0'}:{}">
                  <img v-if="item.logo" :src="item.logo" />
                  <img v-else src="@assets/img/empty.png" />
                  <p>{{item.name}}</p>
                </div>
              </div>
              <div
                class="more m-load"
                v-if="brandTip"
              >
                <span class="load-finish">The end</span>
              </div>
              <div
                class="more m-load"
                v-if="!brandTip"
                @click="loadMore"
              >
                <span class="load-finish">Load More</span>
              </div>
            </div>
          </div>

          <!-- 资质证书 -->
          <div class="section-certificate" v-if="certificateList && certificateList.length">
            <div style="box-shadow:0px 1px 3px 0px rgba(95, 99, 104, 0.1);">
              <div class="title-top">
                <span></span>
                <h3>Certifications</h3>
              </div>
              <div class="section-certificate-list">
                <div v-for="(item,index) in certificateList" @click="certificateFlag=true;certificateInfo=item;" :key="index" :style="(index+1)%6 === 0?{'margin':'0 0 20px 0'}:{}">
                  <img v-if="item.image" :src="item.image" />
                  <img v-else src="@assets/img/empty.png" />
                  <p>{{item.name}}</p>
                </div>
              </div>
              <div
                class="more m-load"
                v-if="certificateTip"
              >
                <span class="load-finish">The end</span>
              </div>
              <div
                class="more m-load"
                v-if="!certificateTip"
                @click="loadMore2"
              >
                <span class="load-finish">Load More</span>
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar" v-if="comInfo">
          <sidebarqrcode :url="url" v-if="url" :showCom="false" :companyMsg="comInfo" :joinInfo="joinInfo"></sidebarqrcode>
          <!-- <div class="sidebar-info" v-if="comInfo.address || comInfo.compTel || comInfo.website || comInfo.businessType">
            <p v-if="comInfo.address">地址：{{comInfo.address}}</p>
            <p v-if="comInfo.compTel">电话：{{comInfo.compTel}}</p>
            <p v-if="comInfo.website">网址：{{comInfo.website}}</p>
            <p v-if="comInfo.businessType">类型：{{comInfo.businessType}}</p>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 品牌详情Modal -->
    <iModal v-model="brandFlag">
      <div slot="header" class="brand-modal">
        <div class="title-top">
          <span></span>
          <h3 v-if="brandInfo">{{brandInfo.name}}</h3>
        </div>
      </div>
      
      <div class="brand-int" v-if="brandInfo && brandInfo.introduction">
        <div v-for="(item,index) in brandInfo.introduction" :key="index">
          <!-- 文字 -->
          <p
            class="int-text"
            v-if="item.text"
            style="padding:10px 0;"
            :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
            v-html="item.text.content ? $service.replaceSpeace(item.text.content) : '暂无介绍'"
          ></p>
          <!-- 图片 -->
          <div
            class="int-img"
            style="font-size:0;"
            v-if="item.picture && item.picture.type == 1"
            :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}"
          >
            <div
              v-for="(itm,idx) in item.picture.list"
              :key="idx"
              :style="{'margin-bottom':item.picture.spacing+'px'}"
            >
              <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)" />
            </div>
          </div>
          <!-- 轮播图片 -->
          <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
            <gSwiperCommon v-if="comInfo" :comInfo="comInfo" :list="item.picture.list"></gSwiperCommon>
          </div>
          <!-- 视频 -->
          <div class="int-video" v-if="item.video">
            <video
              style="width:100%;height:100%;object-fit:fill;"
              :src="item.video.link"
              :poster="item.video.cover?item.video.cover:''"
              controls="controls"
            >您的浏览器不支持video标签</video>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;">No Data！</div>

      <div slot="footer">
        <Button @click="brandFlag=false;brandInfo=null;">Cancel</Button>
      </div>
    </iModal>

    <!-- 证书详情Modal -->
    <iModal v-model="certificateFlag">
      <div slot="header" class="brand-modal">
        <div class="title-top">
          <span></span>
          <h3 v-if="certificateInfo">{{certificateInfo.name}}</h3>
        </div>
      </div>
      
      <p v-if="certificateInfo">Certificate name：{{certificateInfo.name}}</p>
      <p v-if="certificateInfo">Serial number：{{certificateInfo.number}}</p>
      <div class="brand-int" v-if="certificateInfo && certificateInfo.introduction">
        <div v-for="(item,index) in certificateInfo.introduction" :key="index">
          <!-- 文字 -->
          <p
            class="int-text"
            v-if="item.text"
            style="padding:10px 0;"
            :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
            v-html="item.text.content ? $service.replaceSpeace(item.text.content) : '暂无介绍'"
          ></p>
          <!-- 图片 -->
          <div
            class="int-img"
            style="font-size:0;"
            v-if="item.picture && item.picture.type == 1"
            :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}"
          >
            <div
              v-for="(itm,idx) in item.picture.list"
              :key="idx"
              :style="{'margin-bottom':item.picture.spacing+'px'}"
            >
              <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)" />
            </div>
          </div>
          <!-- 轮播图片 -->
          <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
            <gSwiperCommon v-if="comInfo" :comInfo="comInfo" :list="item.picture.list"></gSwiperCommon>
          </div>
          <!-- 视频 -->
          <div class="int-video" v-if="item.video">
            <video
              style="width:100%;height:100%;object-fit:fill;"
              :src="item.video.link"
              :poster="item.video.cover?item.video.cover:''"
              controls="controls"
            >您的浏览器不支持video标签</video>
          </div>
        </div>
      </div>

      <div slot="footer">
        <Button @click="certificateFlag=false;certificateInfo=null;">Cancel</Button>
      </div>
    </iModal>

    <supplyModal :show="supplyOpen" @close="supplyOpen=false" :infoData="comInfo" :infoType="'展商'" />
    <gBottom />
    <gLogin :show="show" @close="show=false;" />
  </div>
</template>

<script>
import gLogin from "@components/En/gLogin/gLogin.vue";
import gTop from "@components/En/gTop/gTop.vue";
import gHead from "@components/En/gHead/gHead.vue";
import gNav from "@components/En/gNav/gNav.vue";
import gBottom from "@components/En/gBottom/gBottom.vue";
import gSwiperCommon from "@components/En/gSwiperCommon/gSwiperCommon.vue"; //轮播图
import leavingmessage from "@components/En/leaving-message"; //留言
import sidebarqrcode from "@components/En/sidebar-QRcode-com"; //边栏 扫描二维码
import supplyModal from "@components/En/modal/supply-modal"; //供需modal
import proList from "./pro-list"; //留言
import { mapGetters, mapActions, mapMutations } from "vuex";
import config from "@assets/config.json";

export default {
  name: "activity-details",
  data() {
    return {
      bodyHeight: "800px",
      joinId: "",
      compId: "",
      comInfo: null,
      introduction: null,
      codeData: null,
      exData: null,
      boothInfo: "",
      categories: "",
      supplyOpen: false,
      url: "",
      show: false,
      
      brandList: [],
      brandFlag: false,
      brandInfo: null,
      brandTip: false,
      brandPageIndex: 1,

      certificateList: [],
      certificateFlag: false,
      certificateInfo: null,
      certificateTip: false,
      certificatePageIndex: 1,

      comDetail: null,
      joinInfo: null,
      exhibitionId:''
    };
  },
  components: {
    gTop,
    gHead,
    gNav,
    gBottom,
    gSwiperCommon,
    leavingmessage,
    sidebarqrcode,
    proList,
    supplyModal,
    gLogin
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exCollectId: "getExCollectId",
      //exhibitionId:'getExhibitionId',
    }),
  },
  watch: {
    "$route"(to, from) {
      if (to) {
        this.introduction = null;
        this.init();
      }
    },
    exCollectId(val, oldVal) {
      this.getComInfo();
    },
    user(val, oldVal) {
      this.getComInfo();
    },
  },
  methods: {
    ...mapMutations({
      setExCollectId: "setExCollectId"
    }),
    ...mapActions({
      getWeAppCode: "exhibitionModule/getWeAppCode",
      getBrand: "exhibitionModule/getBrand",
      getCertificate: "exhibitionModule/getCertificate",
      getCompanyById: "loginModule/getCompanyById",
      getJoinExhibitionInfoByCompId: "exhibitionModule/getJoinExhibitionInfoByCompId",
    }),
    loadMore() {
      this.brandPageIndex += 1;
      this.getComBrand();
    },
    loadMore2() {
      this.certificatePageIndex += 1;
      this.getComCertificate();
    },
    init() {
      this.boothInfo = "";
      this.categories = "";
      this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
      this.joinId = this.$router.history.current.params.id;
      this.compId = this.$router.history.current.query.compId;
      this.exhibitionId=this.$router.history.current.query.exhibitionId
      this.getComInfo();
      this.getCode();
      this.getComBrand();
      this.getComCertificate();
      this.getCom();
      this.getJoinInfo();
    },
    async getJoinInfo() {
      let info = await this.getJoinExhibitionInfoByCompId({
        compId: this.compId,
        exhibitionId: this.exhibitionId
      })
      if (info) {
        info.tempInfo = JSON.parse(info.tempInfo);
      }
      this.joinInfo = info;
    },
    getComInfo() {
      this.setExCollectId("");
      let userId = "";
      if (this.user) {
        userId = this.user.userId;
      }
      this.$http
        .get(`/api/join/compInfo?joinId=${this.joinId}&userId=${userId}` , this.$store.state.header)
        .then(res => {
          if (res.status === 200 && res.data) {
            this.comInfo = res.data;
            if (this.comInfo && this.comInfo.boothInfo) {
              let boothInfo = JSON.parse(this.comInfo.boothInfo);
              for (let i = 0; i < boothInfo.length; i++) {
                if (boothInfo.length > 1) {
                  if (boothInfo[i].Hall && boothInfo[i].Code) {
                    this.boothInfo +=
                    boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
                  }
                  if (!boothInfo[i].Hall && boothInfo[i].Code) {
                    this.boothInfo +=
                    boothInfo[i].Code + "、";
                  }
                  if (boothInfo[i].Hall && !boothInfo[i].Code) {
                    this.boothInfo +=
                    boothInfo[i].Hall + "、";
                  }
                } else {
                  if (boothInfo[i].Hall && boothInfo[i].Code) {
                    this.boothInfo += boothInfo[i].Hall + "-" + boothInfo[i].Code;
                  }
                  if (!boothInfo[i].Hall && boothInfo[i].Code) {
                    this.boothInfo += boothInfo[i].Code;
                  }
                  if (boothInfo[i].Hall && !boothInfo[i].Code) {
                    this.boothInfo += boothInfo[i].Hall;
                  }
                }
              }
            }
            if(this.comInfo &&this.comInfo.listBoothInfo.length>0){
              this.comInfo.listBoothInfo.forEach(e=>{
                e.boothInfo=JSON.parse(e.boothInfo)
              })
            }
            if (this.comInfo && this.comInfo.categories) {
              let categories = JSON.parse(this.comInfo.categories);
              if (categories[0]) {
                if (categories[0].List && categories[0].List.length > 0) {
                  if (categories[0].Name && categories[0].List[0].Name) {
                    this.categories =
                      categories[0].Name + " > " + categories[0].List[0].Name;
                  }
                  if (!categories[0].Name && categories[0].List[0].Name) {
                    this.categories =
                      categories[0].List[0].Name;
                  }
                  if (categories[0].Name && !categories[0].List[0].Name) {
                    this.categories =
                      categories[0].Name;
                  }
                } else {
                  if (categories[0].Name) {
                    this.categories = categories[0].Name;
                  }
                }
              }
            }
            console.log("comInfo:", this.comInfo);
            if (this.comInfo && this.comInfo.introduction) {
              this.introduction = JSON.parse(this.comInfo.introduction);
              this.comInfo.introduction = JSON.parse(this.comInfo.introduction);
            }
            console.log("introduction:", this.comInfo.introduction);
          }
        });
    },
    goWebsite() {
      if (this.comDetail && this.comDetail.website) {
        window.open(this.comDetail.website, "_blank");
      }
    },
    async getCom() {
      let info = await this.getCompanyById(this.compId);
      this.comDetail = info;
    },
    addCollect() {
      if (!this.user) {
        this.$Message.warning("请登录后关注");
        this.show = true;
        return;
      }
      let body = {
            "userId": this.user.userId,
            "compId": this.compId,
          }
      this.$http.post('/api/Follower',body,this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$Message.success("success！");
                    this.init();
                  }else{
                    this.$Message.error("fail,please try again！");
                  }
                })
    },
    async getCode() {
      let opt = {
        targetType: 0,
        targetId: this.joinId,
        scene: this.compId + " " + this.exhibitionId
      }
      let data = await this.getWeAppCode(opt);
      if (data) {
        this.url = data.path;
      }
    },
    supply() {
      if (!this.user) {
        this.$Message.warning("请登录后发布");
        this.show = true;
        return;
      }
      this.supplyOpen = true;
    },
    async getComBrand() {
      let list = await this.getBrand({
        compId: this.compId,
        pageIndex: this.brandPageIndex,
        pageSize: 12
      });
      if (list && list.items.length) {
        list.items.map(c => {
          c.introduction = JSON.parse(c.introduction);
        })
      }
      this.brandList = [...list.items, ...this.brandList];
      if (this.brandList.length >= list.totalCount) {
        this.brandTip = true;
      }
    },
    async getComCertificate() {
      let list = await this.getCertificate({
        compId: this.compId,
        pageIndex: this.certificatePageIndex,
        pageSize: 12
      });
      if (list && list.items.length) {
        list.items.map(c => {
          c.introduction = JSON.parse(c.introduction);
        })
      }
      this.certificateList = [...list.items, ...this.certificateList];
      if (this.certificateList.length >= list.totalCount) {
        this.certificateTip = true;
      }
    },
  }
};
</script> 

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.home {
  background: #f5f5f5;
}
.gContent {
  background: #f5f5f5;
  width: 1200px;
  margin: 20px auto 0;
}
.top-title {
  height: 50px;
  font-size: 14px;
  line-height: 35px;
  &-link {
    color: #999;
  }
}
.main {
  width: 1200px;
  margin-top: 20px;
  margin-bottom: 80px;
  @include clearfix;

  .section {
    width: 878px;
    border-radius: 2px;
    background-color: #fff;
    float: left;
    .section-top {
      // padding: 50px 65px;
      box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
      border-bottom: 20px solid #f5f5f5;
      .m-content {
        padding: 23px 60px 50px;
      }
    }
    .title {
      position: relative;
      padding-left: 20px;
      display: flex;
      align-items: center;
      height: 60px;
      border-bottom: 1px solid #f5f5f5;
      span {
        display: inline-block;
        width: 4px;
        height: 16px;
        background-color: #d13119;
      }
      h3 {
        display: inline-block;
        font-size: 16px;
        line-height: 18px;
        color: #333;
        margin-left: 15px;
      }
    }
  }

  .sidebar {
    width: 300px;
    float: right;
    @include empty-txt(200px, "加载中...");
  }
}

.m-info {
  height: 160px;
  background-color: #fff;
  padding: 20px;
  margin-top: 28px;
  &-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    // margin-bottom: 10px;
  }
  &-brand {
    display: flex;
    align-items: center;
    // margin-bottom: 6px;
    .brand {
      align-items: center;
      display: flex;
      margin-right: 15px;
      color: #999;
      span {
        font-size: 16px;
      }
      i {
        font-size: 22px;
      }
      .icon-chakan {
        font-size: 24px;
      }
    }
  }
  &-line {
    margin-right: 10px;
    // margin-bottom: 4px;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
    }
  }
}
.m-content {
  p {
    padding: 43px 0;
  }
  img {
    width: 100%;
  }
}
.section-bot {
  border-bottom: 20px solid #f5f5f5;
  width: 100%;
  background-color: #fff;
}
.section-brand {
  border-bottom: 20px solid #f5f5f5;
  width: 100%;
  background-color: #fff;
  .title-top{
    position: relative;
    padding-left: 20px;
    display: flex;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #f5f5f5;
    span{
        display: inline-block;
        width: 4px;
        height: 16px;
        background-color: #d13119;
    }
    h3{
        display: inline-block;
        font-size: 16px;
        line-height: 18px;
        color: #333;
        margin-left: 15px;
    }
  }
  &-list {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    div {
      margin: 0 23px 20px 0;
      width: 120px;
      cursor: pointer;
    }
    img {
      width: 120px;
      height: 120px;
      border: solid 1px #f2eded;
    }
    p {
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }
}
.brand-modal {
  .title-top{
    position: relative;
    display: flex;
    align-items: center;
    span{
      display: inline-block;
      width: 4px;
      height: 16px;
      background-color: #d13119;
    }
    h3{
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      color: #333;
      margin-left: 15px;
      font-weight: normal;
    }
  }
}

.section-certificate {
  border-bottom: 20px solid #f5f5f5;
  width: 100%;
  background-color: #fff;
  .title-top{
    position: relative;
    padding-left: 20px;
    display: flex;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #f5f5f5;
    span{
        display: inline-block;
        width: 4px;
        height: 16px;
        background-color: #d13119;
    }
    h3{
        display: inline-block;
        font-size: 16px;
        line-height: 18px;
        color: #333;
        margin-left: 15px;
    }
  }
  &-list {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    div {
      margin: 0 23px 20px 0;
      width: 120px;
      cursor: pointer;
    }
    img {
      width: 120px;
      height: 168px;
      border: solid 1px #f2eded;
    }
    p {
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }
}

.company_info {
  height: 200px;
  padding: 20px 18px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  border-bottom: 1px solid #ebebec;
  margin-bottom: 20px;
  position: relative;
  background-color: #fff;
  display: flex;
  align-items: center;
  .img {
    border: 1px solid rgba(204, 204, 204, 0.4);
    width: 158px;
    height: 158px;
    float: left;
    @include clearfix;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.company_info .info {
  float: left;

  @include clearfix;

  margin-left: 20px;

  h3 {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: #333;
    padding-bottom: 10px;
    width: 25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.company_info .btn {
  height: 100%;
  position: absolute;
  top: 20px;
  right: 20px;
}
.int-video {
  width: 750px;
  height: 500px;
  margin: 10px 0;
}
.brand-int {
  .int-video {
    width: 100%;
    // height: 200px;
    height: auto;
    margin: 10px 0;
  }
}
.sidebar-info {
  width: 300px;
  padding: 30px;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  background-color: #fff;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  p {
    font-size: 16px;
    color: rgb(0, 0, 0);
    margin-bottom: 20px;
    text-align: left;
    &:first-child,
    &:last-child {
      margin-bottom: 0;
    }
    span {
    font-size: 16px;
    color: rgb(0, 0, 0);
    }
  }
}
.website {
  color: #1890ff;
  cursor: pointer;
}
.more {
  height: 80px;
  text-align: center;
}
.more span {
  color: #040000;
  font-size: 14px;
  cursor: pointer;
  line-height: 80px;
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>